import { useQuery } from "react-query";
import http from "infra/http";
import { CarteirasResponse } from "../typings";

function useGetCarteiras(bancoId: string) {
  return useQuery(
    `/v1/bancos/${bancoId}/carteiras`,
    async () => {
      const { data } = await http.get<CarteirasResponse[]>(
        `/v1/bancos/${bancoId}/carteiras`
      );

      return data;
    },
    {
      enabled: !!bancoId,
    }
  );
}

export default useGetCarteiras;
